import React, { useEffect, useState } from "react"
import { HashRouter, Route, Switch } from "react-router-dom"
import smoothscroll from 'smoothscroll-polyfill'
import Search from "./screens/Search" // can probably move this to App
import Timeline from "./screens/Timeline"
import Splash from "./screens/Splash"
import Test from "./screens/Test"
import RotateScreen from "./screens/RotateScreen"
import Modal from "./components/Modal"

smoothscroll.polyfill()

const App = (props) => {
  /**
   * Make this your router:
   * - lands on splash screen, scroll to Welcome ('/')
   * - Button links to Search page ('/search')
   * - Button links to Timeline page ('/timeline')
   * - Dynamic route to individual? ('/honoree/:id')
   */

  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (
      window.innerWidth < window.innerHeight ||
      (window.screen.orientation &&
        window.screen.orientation.type.includes("portrait")) ||
      (window.screen.msOrientation &&
        window.screen.msOrientation.includes("portrait"))
    ) {
      setShowModal(true)
    } else {
      setShowModal(false)
    }
    window.addEventListener("resize", () => {
      if (
        window.innerWidth < window.innerHeight ||
        (window.screen.orientation &&
          window.screen.orientation.type.includes("portrait")) ||
        (window.screen.msOrientation &&
          window.screen.msOrientation.includes("portrait"))
      ) {
        setShowModal(true)
      } else {
        setShowModal(false)
      }
    })
  })

  return (
    <>
      <Modal show={showModal} title='Rotate your screen' showConfetti={false}>
        <RotateScreen />
      </Modal>
      <HashRouter>
        <Switch>
          <Route exact path='/' component={Splash} />
          <Route exact path='/timeline' component={Timeline} />
          <Route exact path='/search' component={Search} />
          <Route exact path='/test' component={Test} />
        </Switch>
      </HashRouter>
    </>
  )
}

export default App
